export { default as KpiGlobalPerformancePanel } from "./KpiGlobalPerformancePanel.vue";
export * from "./config";
